<template>
  <!-- 备货审批详情 -->
  <stockup-check :pagetitle="`备货审批详情`" :sna-id="snaId"></stockup-check>
</template>

<script>
import stockupCheck from '@/views/workbench/workCheckManage/stockupCheck/stockupCheck'
import checkMixin from '@/mixin/checkMixin'
import routerMixin from '@/mixin/routerMixin'

export default {
  name: 'stockCheckView',
  components: {
    stockupCheck
  },
  mixins: [checkMixin, routerMixin]
}
</script>

<style scoped></style>
